import React from 'react'
import { FiMoreHorizontal } from 'react-icons/fi'
import { projectSettingList } from './mock';
  
export const ProjectItem = ({item}) =>{

    const [open, setOpen] = React.useState(false);

    return(
        <li>
            <div>
                <div className="title">{item.title}</div>
                <div className="images">

                {
                    true && item?.images?.length>0 && item.images.map((image,i)=> <img src={`/assets/images/faces/${image}.png`} key={'image'+i} alt="" />)
                }
                {
                    item?.team?.filter((t)=>t.status===4).length>0 &&  item?.team?.filter((t)=>t.status===4).map((item)=>{
                            return (
                                <a href={`/users/${item?.from._id}`} key={'project-person'+item}>
                                    {item.from.avatar && <img src={`${item.from.avatar}`} alt={item.from.name} draggable="false"  />}
                                    {!item.from.avatar && <img src="/assets/images/faces/default.svg"  alt={item.from.name} draggable="false"  /> }
                                </a>
                            )
                        })
                    }


                </div>
                <div className="setting all-unselectable">
                    <div onClick={()=>setOpen(!open)}>
                        <FiMoreHorizontal />
                    </div>    
                   {  open && (
                        <div className="dropdown setting-dropdown">
                            <ul>
                                {projectSettingList.map((item,i)=>(
                                    <li key={'projectsetting'+i}>
                                        {item.symbol}
                                        {item.title}
                                    </li>
                                ))}
                            </ul>
                        </div>
                   )}
                </div>
            </div>
        </li>
    )
} 
